export default function (/**@type {ApisauceInstance} */ api) {
  const getAllSupervisors = (paging) =>
    api.get(`Supervisor/supervisors`, paging);
  const getAllSupervisorsTasks = (paging) =>
    api.get(`Survey/supervisor-rate-tasks`, paging);
  const getAllSupervisorsSpots = (paging) =>
    api.get(`Survey/supervisor-spot-check-tasks`, paging);
  const getAllStocks = (paging) => api.get(`Survey/actual-stock-tasks`, paging);

  const addSupervisor = (payload) => api.post(`Supervisor/supervisor`, payload);

  const getSupervisor = (id) => api.get(`Supervisor/${id}`);
  const editSupervisor = ({ payload, id }) =>
    api.put(`Supervisor/edit-supervisor/${id}`, payload);

  const deleteSupervisor = (id) =>
    api.delete(`Supervisor/delete-supervisor/${id}`);

  return {
    Supervisors: {
      getAllSupervisors,
      addSupervisor,
      editSupervisor,
      deleteSupervisor,
      getSupervisor,
      getAllSupervisorsTasks,
      getAllSupervisorsSpots,
      getAllStocks,
    },
  };
}
